import { axios } from "@/utils";

export const LoginService = async (params: any) => {
  return await axios.post(`/monitrees-oauth-bff/v1/user/login`, {
    ...params,
  });
};

export const LogOutService = async () => {
  return await axios.post(`/monitrees-monitor-bff/v1/user/logout`, {});
};

export const ForgetPasswordService = async (params: any) => {
  return await axios.post(`/monitrees-oauth-bff/v1/user/forget-password`, {
    ...params,
  });
};

export const ChangePasswordService = async (params: any) => {
  return await axios.put(`/monitrees-monitor-bff/v1/user/change-password`, {
    ...params,
  });
};

export const VerifyPasswordService = async (params: any) => {
  return await axios.post(`/monitrees-oauth-bff/v1/user/verify-password`, {
    ...params,
  });
};

export const RegisterService = async (params: any) => {
  return await axios.post(`/monitrees-oauth-bff/v1/user/register`, {
    ...params,
  });
};

export const UserService = async () => {
  return await axios.get(`/monitrees-monitor-bff/user-info`);
};

export const BindKeyService = async (params: any) => {
  return await axios.post(`/monitrees-monitor-bff/monitor/bind`, {
    ...params,
  });
};

export const SettingsService = async (params: any) => {
  return await axios.put(`/monitrees-monitor-bff/user-info`, {
    ...params,
  });
};
